var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM7.19743 7.99929L4.1728 4.97519H4.16708C3.94431 4.75245 3.94431 4.38979 4.16708 4.16705C4.38986 3.94432 4.75259 3.94432 4.97537 4.16705L8 7.19115L11.0246 4.16705C11.2474 3.94432 11.6101 3.94432 11.8329 4.16705C12.0557 4.38979 12.0557 4.75245 11.8329 4.97519L8.80828 7.99929L11.8329 11.0234C12.0557 11.2461 12.0557 11.6088 11.8329 11.8315C11.7215 11.9429 11.5759 12 11.4302 12C11.2845 12 11.1389 11.9429 11.0275 11.8315L8.00286 8.80743L4.97822 11.8315C4.86683 11.9429 4.72117 12 4.57551 12C4.42985 12 4.28418 11.9429 4.1728 11.8315C3.95002 11.6088 3.95002 11.2461 4.1728 11.0234L7.19743 7.99929Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.952ff7e133ce3959a89e3ce1c2a4d6ad.svg";
export { ForwardRef as ReactComponent };